// Modal.js

import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface HpModalProps{
    isOpen: boolean,
    onClose: ()=> void,
    handleDamage:(num: number)=>void
    handleHeal:(num: number)=>void

}

const HpModal = (props: HpModalProps) => {
    const [isDamage, setIsDamage] = useState(true);
    const [delta, setDelta] = useState(0);
    const backgroundaRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation();

    if (!props.isOpen) return null;
    return (
        
        <div className="modal" tabIndex={-1} style={{display: "block"}}>
            <div 
                ref={backgroundaRef}
                className="modal-background"
                tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" 
                onClick={e=>{
                    if(e.target === backgroundaRef.current)
                    {
                        props.onClose();
                    }
                }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                    
                        <div className="modal-body">
                            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                <input type="radio" className="btn-check" name="damageradio" id="damageradio" autoComplete="off" checked={isDamage} onChange={e=>setIsDamage(e.target.checked)}/>
                                <label className="btn btn-outline-primary" htmlFor="damageradio">{t("hpmodal-damage")}</label>
                                <input type="radio" className="btn-check" name="healradio" id="healradio" autoComplete="off" checked={!isDamage} onChange={e=>setIsDamage(!e.target.checked)}/>
                                <label className="btn btn-outline-primary" htmlFor="healradio">{t("hpmodal-heal")}</label>
                            </div>
                            <div className="m-2">
                                <input type="number" className="text-center" value={delta} onChange={e=>setDelta(parseInt(e.target.value))}/>
                            </div>
                            <div className="d-flex justify-content-center">
                                <button type="button" className="btn btn-secondary m-1" onClick={e=>props.onClose()}>{t("modal-close")}</button>
                                <button type="button" className="btn btn-primary m-1" onClick={e=>{
                                    if (isDamage){
                                        props.handleDamage(delta);
                                    }else{
                                        props.handleHeal(delta);
                                    }
                                }}>{t("modal-save")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HpModal;
